import "./Buttons.scss";

import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Schedule from "../../assets/images/icons/icon_bt_schedule.svg";

const ButtonSchedule = ({ justSchedule, openSchedule }) => {
  const { t } = useTranslation();

  return (
    <div className="containerButton">
      <div className={`divButtons ${justSchedule ? "nogap" : ""}`}>
        {!justSchedule && (
          <Link to="/calendar">
            <button>
              <img src={Schedule} alt="View Schedule" />
              {t("BTN_VIEW_SCHEDULE")}{" "}
            </button>
          </Link>
        )}
        <button className="scheduleClass" onClick={openSchedule}>
          <i className="fa fa-plus" aria-hidden="true"></i>
          {t("BTN_SCHEDULE_CLASS")}
        </button>
      </div>
    </div>
  );
};

export default ButtonSchedule;
